import { MomentmSettingsDataGrid } from '../management/MomentmSettingsDataGrid';

export function MomentmSettingsTab() {
  return (
    <div className="flex-col gap-4">
      <MomentmSettingsDataGrid />
    </div>
  );
}
